import { useCirCleContext } from '../contexts/CircleContext';
import { useStepName } from './useStepName';
import * as React from 'react';
import { Steps } from '../consts/step';
import { PostInitScenarioPolicyData } from '../types/api';
import { useUnConfigBootStoreContext } from '../contexts/UnConfigBootStoreContext';
import { initScenarioPolicy } from '../service';
import { useConfigurationId } from './useConfigurationId';

/**
 * 在配置引导里。基础配置或进阶配置的每一个阶段，不管是确认内容还是跳过
 * 都需要去初始化其他的关联场景的配置
 * 在基础配置里，应该判断进店欢迎语和超时自动回复哪个是基础接待的最后一个环节，需要去请求
 */
export const useInitOtherScenario = () => {
  const { circle } = useCirCleContext();
  const stepName = useStepName();
  const stepNameMapRef = React.useRef<
    Partial<Record<Steps, PostInitScenarioPolicyData['scenarioGroup']>>
  >({
    [Steps.WELCOME_MESSAGE]: 'BASIC_RECEPTION',
    [Steps.AUTO_REPLY_ON_TIMEOUT]: 'BASIC_RECEPTION',
    [Steps.LOGISTICS_CARE]: 'LOGISTICS_CARE',
    [Steps.ABANDONED_CART_RECOVERY]: 'CANCEL_AND_RETURN_SAVE',
    [Steps.REVIEW_MANAGEMENT]: 'REVIEW_MANAGE',
  });
  const allStores = useUnConfigBootStoreContext();
  const configurationId = useConfigurationId();

  return React.useCallback(() => {
    const condition1 =
      circle.includes(Steps.AUTO_REPLY_ON_TIMEOUT) && stepName === Steps.AUTO_REPLY_ON_TIMEOUT;
    const condition2 =
      !circle.includes(Steps.AUTO_REPLY_ON_TIMEOUT) &&
      circle.includes(Steps.WELCOME_MESSAGE) &&
      stepName === Steps.WELCOME_MESSAGE;
    const condition3 =
      stepName === Steps.LOGISTICS_CARE ||
      stepName === Steps.ABANDONED_CART_RECOVERY ||
      stepName === Steps.REVIEW_MANAGEMENT;

    if (condition1 || condition2 || condition3) {
      const storeIds = allStores.map((store) => store.storeId);

      initScenarioPolicy({
        storeIds,
        scenarioGroup: stepNameMapRef.current[stepName]!,
        configurationId,
      }).catch(() => {});
    }
  }, [circle, stepName, allStores, configurationId]);
};
